import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

import type { TrackingData } from '@ecomm/tracking-types/Data'

export function useTrackingAppCarousel() {
  const { trackEvent } = useTracking<TrackingData>()

  return useCallback(
    (carouselName: string) => {
      trackEvent({
        event: 'carousel-click-app-component',
        carouselName
      })
    },
    [trackEvent]
  )
}
